import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Same breakpoint as Tailwind's `md` (768px): below it the coach gets the
 * mobile layout (bottom nav, no sidebar).
 */
export const COACH_DESKTOP_QUERY = '(min-width: 768px)';

// No matchMedia (jsdom, very old browsers): assume desktop, so the coach
// desktop is what renders whenever the width cannot be read.
const readIsDesktop = () =>
  typeof window === 'undefined' || typeof window.matchMedia !== 'function'
    ? true
    : window.matchMedia(COACH_DESKTOP_QUERY).matches;

/**
 * True when a coach is on the phone layout — the only case where the coach
 * screens take the student mobile look (background, header, bottom nav).
 *
 * Read through JS rather than `md:` classes alone wherever the two layouts
 * render different components, or where a component has side effects even
 * when hidden (StudentAmbientBackground repaints the status bar). From 768px
 * up it is always false, so the coach desktop never sees any of it.
 */
export default function useIsCoachMobile() {
  const { user } = useAuth();
  const [isDesktop, setIsDesktop] = useState(readIsDesktop);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const media = window.matchMedia(COACH_DESKTOP_QUERY);
    const onChange = () => setIsDesktop(media.matches);
    onChange();
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, []);

  return Boolean(user) && user.role !== 'student' && !isDesktop;
}
